import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { ref, defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'indexLists',
  setup(__props) {

const defaultLists = defineAsyncComponent(() => import("@/components/theme/uikits/lists/defaultLists.vue"))
const activeLists = defineAsyncComponent(() => import("@/components/theme/uikits/lists/activeLists.vue"))
const flushLists = defineAsyncComponent(() => import("@/components/theme/uikits/lists/flushLists.vue"))
const contextualClasses = defineAsyncComponent(() => import("@/components/theme/uikits/lists/contextualClasses.vue"))
const horizontalLists = defineAsyncComponent(() => import("@/components/theme/uikits/lists/horizontalLists.vue"))
const customList = defineAsyncComponent(() => import("@/components/theme/uikits/lists/customList.vue"))
const checkboxRedio = defineAsyncComponent(() => import("@/components/theme/uikits/lists/checkboxRedio.vue"))
const numberList = defineAsyncComponent(() => import("@/components/theme/uikits/lists/numberList.vue"))
const javaScriptBehavior = defineAsyncComponent(() => import("@/components/theme/uikits/lists/javaScriptBehavior.vue"))
const badgeList = defineAsyncComponent(() => import("@/components/theme/uikits/lists/badgeList.vue"))
const disabledLists = defineAsyncComponent(() => import("@/components/theme/uikits/lists/disabledLists.vue"))
const scrollableLists = defineAsyncComponent(() => import("@/components/theme/uikits/lists/scrollableLists.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Ui Kits",
      title: "Lists"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(defaultLists)),
        _createVNode(_unref(activeLists)),
        _createVNode(_unref(flushLists)),
        _createVNode(_unref(contextualClasses)),
        _createVNode(_unref(horizontalLists)),
        _createVNode(_unref(customList)),
        _createVNode(_unref(checkboxRedio)),
        _createVNode(_unref(numberList)),
        _createVNode(_unref(javaScriptBehavior)),
        _createVNode(_unref(badgeList)),
        _createVNode(_unref(disabledLists)),
        _createVNode(_unref(scrollableLists))
      ])
    ])
  ], 64))
}
}

})